var _path, _path2, _path3, _path4, _ellipse, _ellipse2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCrown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 49,
  height: 48,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#crown_svg__a)",
  d: "m17.128 19.798 5.824-10.05a1.5 1.5 0 0 1 2.596 0l5.824 10.05a1.5 1.5 0 0 0 1.685.698L45.74 17.11a1.5 1.5 0 0 1 1.835 1.839L42.48 37.898a1.5 1.5 0 0 1-1.449 1.11H7.47a1.5 1.5 0 0 1-1.448-1.11L.925 18.948A1.5 1.5 0 0 1 2.76 17.11l12.683 3.386a1.5 1.5 0 0 0 1.685-.698"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#crown_svg__b)",
  d: "M17.256 19.463 21.58 12c.768-1.326 2.797-.78 2.797.752v24.42a1.5 1.5 0 0 1-1.5 1.5H7.598a1.5 1.5 0 0 1-1.448-1.11L1.053 18.613a1.5 1.5 0 0 1 1.835-1.839l12.683 3.386a1.5 1.5 0 0 0 1.685-.697"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#crown_svg__c)",
  d: "m2.5 17.258 13.086 3.29a.75.75 0 0 1 .466 1.105l-2.232 3.84a.75.75 0 0 1-1.127.201z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#crown_svg__d)",
  d: "M24.29 36.72 25 9.382l7.65 12.519a1.5 1.5 0 0 0 1.703.657l9.009-2.65c1.139-.335 2.197.724 1.862 1.863l-4.532 15.41a1.5 1.5 0 0 1-1.44 1.076H25.79a1.5 1.5 0 0 1-1.5-1.539"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 5.691,
  cy: 11.161,
  fill: "url(#crown_svg__e)",
  rx: 5.691,
  ry: 11.161,
  transform: "matrix(.82452 -.56583 .61489 .78862 -1.25 21.44)"
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.482,
  cy: 4.868,
  fill: "url(#crown_svg__f)",
  rx: 2.482,
  ry: 4.868,
  transform: "matrix(.82452 -.56583 .61489 .78862 5.265 24.587)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "crown_svg__a",
  x1: 27.918,
  x2: -3.442,
  y1: -0.24,
  y2: 2.651,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EBB446"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EBB446"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "crown_svg__b",
  x1: 10.128,
  x2: 19.503,
  y1: 28.923,
  y2: 27.798,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFCD6A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFCD6A",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "crown_svg__c",
  x1: -2.75,
  x2: 20.123,
  y1: 13.508,
  y2: 19.028,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AA641A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#AA641A",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "crown_svg__d",
  x1: 40.375,
  x2: 19.75,
  y1: 24.008,
  y2: 29.258,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AA641A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#AA641A",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "crown_svg__e",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(0 11.1607 -5.69062 0 5.69 11.16)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFEBC4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFEBC4",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "crown_svg__f",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(0 4.868 -2.48209 0 2.482 4.868)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFEBC4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFEBC4",
  stopOpacity: 0
})))));
export { SvgCrown as ReactComponent };
export default __webpack_public_path__ + "../icons/e93c05efe19ab65bf24ded0b91933477.svg";